import CommonFooter from "@/components/footer/footer"
import CommonHeader from "@/components/header/header"
import { Outlet } from "react-router"

export default function Default() {
  return (
    <>
      <CommonHeader />
      <main
        className={`
            relative
            pt-8 md:pt-20
            min-h-[calc(100vh-250px)]
            overflow-visible
            text-main
          `}
        id="top"
      >
        <Outlet />
        <i
          className={`
              absolute left-[-77px] bottom-[-120px] z-0
              size-60
              rounded-full
              bg-theme-main
              opacity-20 blur-3xl
              hidden md:block
            `}
        />
      </main>
      <CommonFooter />
    </>
  )
}
